import { Combobox, Dropdown, Stack } from "@adfenix/alexandria";
import { getHqAndDomains } from "api/services";
import { getUserHqs, userSelectedHq } from "atoms/auth";
import Divider from "components/Divider";
import useUserInfo from "hooks/useUserInfo";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { RealforceLogo } from "static/svg/realforce-logo";
import { reactSelectDark } from "style/reactSelectDark";

import { AppMode } from ".";
import { ConfigurationService } from "@adfenix/types";

interface Props {
  appMode: AppMode;
  setAppMode: (mode: AppMode) => void;
  isLoadingReport: boolean;
  selectedHq?: ConfigurationService.HqAndDomainModel;
}

export const SidebarHeader = ({ appMode, setAppMode }: Props) => {
  const { permissions, userEmail, accessLevel } = useUserInfo();
  const navigate = useNavigate();
  const [selectedHq, setSelectedHq] = useRecoilState(userSelectedHq);
  const userHqs = useRecoilValue(getUserHqs);
  const { data: hqs } = useQuery(
    ["getHqAndDomains", userEmail],
    getHqAndDomains,
    {
      enabled: Boolean(userEmail),
      select: data =>
        [...data]
          .filter(
            hq =>
              accessLevel === "Multi-Brand" ||
              (userHqs.includes(hq.id) && hq.active)
          )
          .sort((a, b) =>
            a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1
          )
    }
  );

  const userHqCount = hqs?.length ?? 0;

  const dropdownStyle = {
    backgroundColor: "#050b1f",
    color: "#f8f9fe"
  };

  return (
    <>
      <Stack spacing="m">
        <RealforceLogo />

        {appMode === "Customer" && userHqCount > 1 && selectedHq && (
          <Combobox
            items={hqs ?? []}
            styles={reactSelectDark}
            valueObjectIndexAccessor="name"
            onChange={hq => setSelectedHq(hq)}
            defaultItem={selectedHq}
          />
        )}

        {permissions?.UserDomain.includes("Edit") && (
          <Dropdown
            style={dropdownStyle}
            items={["Customer", "Back Office"]}
            data-testid="back-office-toggle"
            value={appMode}
            onChange={mode => {
              setAppMode(mode as AppMode);

              if (mode === "Customer") {
                const url = selectedHq
                  ? `/customer/hq/${selectedHq.id}/property`
                  : "/property/list";
                navigate(url);
              } else {
                navigate("/back-office/campaign");
              }
            }}
          />
        )}
      </Stack>
      <Divider dark margin={`24px 0`} />
    </>
  );
};
